var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9059 0.576C11.7409 0.225 11.3879 0 10.9999 0H0.999851C0.611851 0 0.258851 0.225 0.0938508 0.576C-0.0701492 0.928 -0.0161492 1.343 0.231851 1.64L5.23185 7.64C5.42185 7.868 5.70285 8 5.99985 8C6.29685 8 6.57785 7.868 6.76785 7.64L11.7679 1.64C12.0169 1.343 12.0698 0.928 11.9059 0.576Z",
    fill: "#353E53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caretDown.e7053c95cd38388156481b8b24c34973.svg";
export { ForwardRef as ReactComponent };